export default {
  setBreadcrumbs: (state, payload) => {
    state.breadcrumbs = [];
    let dashboard = false;

    if (payload.dashboardNome) {
      if (payload.dashboardNome == payload.obj.page) {
        dashboard = true;
      }
    }

    if (!dashboard) {
      if (payload.obj) {
        if (payload.obj.nameGrandParent) {
          state.breadcrumbs.push({
            text: payload.obj.nameGrandParent,
            disabled: false
          });
        }

        if (payload.obj.nameParent) {
          state.breadcrumbs.push({
            text: payload.obj.nameParent,
            disabled: false
          });
        }

        if (payload.obj.name) {
          state.breadcrumbs.push({
            text: payload.obj.name,
            disabled: true
          });
        }
      }
    } else {
      state.breadcrumbs = [];
    }
  }
};
